module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"welcome":"Войдите, чтобы начать работу","forgotPassword":"Забыли пароль?","enter":"Войти","error":{"400":"Неверный логин или пароль!","403":"Доступ запрещен!","404":"Такого пользователя не существует!","connection":"Нет соединения с сервером!","default":"Неизвестная ошибка!"}}}')
  delete Component.options._Ctor
}
